import { cn } from "@/lib/utils";

// ─────────────────────────────────────────────
// EmptyState
//
// Per-screen empty state with icon, title, description,
// and optional action button.
// Design: §9.12 Empty State Pattern
// ─────────────────────────────────────────────

interface EmptyStateProps {
  icon?: React.FC<{ className?: string }>;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
  className?: string;
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-4 px-6 py-12 text-center",
        className
      )}
    >
      {Icon && (
        <div className="flex h-16 w-16 items-center justify-center">
          <Icon className="h-16 w-16 text-text-muted" />
        </div>
      )}

      <div className="flex flex-col gap-2">
        <h3 className="text-[18px] font-semibold text-text-primary">{title}</h3>
        {description && (
          <p className="max-w-sm text-body text-text-secondary">{description}</p>
        )}
      </div>

      {action && (
        <button
          type="button"
          onClick={action.onClick}
          className="mt-2 flex items-center gap-2 rounded-control px-4 py-2 text-[14px] font-medium text-white transition-opacity hover:opacity-90"
          style={{ backgroundColor: "var(--accent)" }}
        >
          {action.label}
        </button>
      )}
    </div>
  );
}
